var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9974 88.3332C21.065 88.3332 1.66406 68.932 1.66406 44.9998C1.66406 21.0675 21.065 1.6665 44.9974 1.6665C68.9295 1.6665 88.3307 21.0675 88.3307 44.9998C88.3307 68.932 68.9295 88.3332 44.9974 88.3332ZM44.9974 79.6665C64.1434 79.6665 79.6641 64.1458 79.6641 44.9998C79.6641 25.854 64.1434 10.3332 44.9974 10.3332C25.8515 10.3332 10.3307 25.854 10.3307 44.9998C10.3307 64.1458 25.8515 79.6665 44.9974 79.6665ZM40.6753 62.3332L22.2907 43.9486L28.419 37.8199L40.6753 50.0768L65.1886 25.5636L71.3168 31.6919L40.6753 62.3332Z",
    stroke: "url(#paint0_linear_4747_3496)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4747_3496",
    x1: -7.19101,
    y1: -13.4179,
    x2: 91.726,
    y2: 32.6339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23AC49",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23AC49",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSuccess);
export default __webpack_public_path__ + "static/media/CircleSuccess.1ef109397a598e3dfdfd47e2ce5ced34.svg";
export { ForwardRef as ReactComponent };